import translate from '@translate';
import React, { FC, useEffect } from 'react';
import Select, { OnChangeType, SelectValueType } from 'src/components/Select';
import { getZasilkovnaCarriersListFetch, getZasilkovnaCarriersFetch } from 'src/resources/zasilkovna/reducer';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import { hasPickupPoints } from 'src/resources/zasilkovna/functions';

export interface ZasilkovnaExternalSelectPropsType {
    onChange: OnChangeType;
    value: SelectValueType;
    error?: boolean;
    name?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
    serviceCode?: string;
}

const ZasilkovnaExternalSelect: FC<ZasilkovnaExternalSelectPropsType> = (props) => {
    const dispatch = useDispatch();

    const dataCarriersAddress = useSelector((state: RootStoreType) => state.zasilkovna.dataCarriersAddress);
    const dataCarriersRaw = useSelector((state: RootStoreType) => state.zasilkovna.dataCarriersRaw);
    const loading = useSelector((state: RootStoreType) => state.zasilkovna.loading);

    const serviceCode = props.serviceCode ? Number(props.serviceCode) : null;

    // Load carriers list once if not loaded
    useEffect(() => {
        if (!dataCarriersRaw) {
            dispatch(getZasilkovnaCarriersListFetch());
        }
    }, [dataCarriersRaw, dispatch]);

    // Check if carrier has pickup points enabled
    const carrierHasPickupPoints = hasPickupPoints(dataCarriersRaw, serviceCode);

    // Load addresses for specific carrier if not loaded (only if carrier has pickup points)
    useEffect(() => {
        if (serviceCode && carrierHasPickupPoints && !dataCarriersAddress?.[serviceCode]) {
            dispatch(getZasilkovnaCarriersFetch(serviceCode));
        }
    }, [dataCarriersAddress, serviceCode, carrierHasPickupPoints, dispatch]);

    // Don't render if carrier doesn't have pickup points
    if (!carrierHasPickupPoints) {
        return null;
    }

    if (!serviceCode || !dataCarriersAddress?.[serviceCode]) {
        return null;
    }

    return (
        <Select
            options={dataCarriersAddress[serviceCode]}
            value={props.value}
            error={props.error}
            onChange={props.onChange}
            name={props.name}
            label={props.label}
            required={props.required}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            loading={loading}
            virtualized
        />
    );
};

export default ZasilkovnaExternalSelect;
